export const getIsFetchingSegmapList = (state, props) => state.commonReducers.params.isSegmapListFetching;
export const getIsSegmapListFetched = (state, props) => state.commonReducers.params.isSegmapListFetched;
export const getSegmapList = (state, prop) => state.commonReducers.storeFetchedSegmapList
export const getCompanyList = (state, prop) => state.commonReducers.storeFetchedCompanyList
export const getIsFetchingCostCategory = (state, props) => state.commonReducers.params.isCostCategoryFetching;
export const getIsCostCategoryFetched = (state, props) => state.commonReducers.params.isCostCategoryFetched;
export const getCostCategoryList = (state, prop) => state.commonReducers.storeFetchedCostCategory
export const getIsFetchingCostCenter = (state, props) => state.commonReducers.params.isCostCenterFetching;
export const getIsCostCenterFetched = (state, props) => state.commonReducers.params.isCostCenterFetched;
export const getCostCenterList = (state, prop) => state.commonReducers.storeFetchedCostCenter

export const getAlertModalState = (state) => state.commonReducers.alertModalState;
